<template>
  <div class="p20">
    <h1>岗位管理</h1>
  </div>
</template>

<script>
export default {
  name: 'PostManagement',
  data() {
    return {
      // 在此添加组件数据
    }
  },
  methods: {
    // 在此添加组件方法
  }
}
</script>

<style scoped>

</style>